import { render, staticRenderFns } from "./SyncRatesModal.vue?vue&type=template&id=79f6ddb0&lang=pug"
import script from "./SyncRatesModal.vue?vue&type=script&lang=js"
export * from "./SyncRatesModal.vue?vue&type=script&lang=js"
import style0 from "./SyncRatesModal.vue?vue&type=style&index=0&id=79f6ddb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports